import type { UserStats } from "@mk/shared";

/** Profile and statistics use the same lifetime 1v1 total. */
export function combinedDuelRecord(stats: UserStats | null) {
  const wins = (stats?.duelWins ?? 0) + (stats?.friendlyDuelWins ?? 0);
  const losses = (stats?.duelLosses ?? 0) + (stats?.friendlyDuelLosses ?? 0);
  const draws = (stats?.duelDraws ?? 0) + (stats?.friendlyDuelDraws ?? 0);
  return { wins, losses, draws, total: wins + losses + draws };
}
